import React from 'react'

function NRCintern() {
  return (
    <div>
      <h1>Nutrition Rehabilitation Center: Internship blog</h1>
      <h1>Coming soon.....</h1>
    </div>
  )
}

export default NRCintern
